/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetInteractionsMutationVariables = Types.Exact<{
  interactions: Types.Scalars["PartialUserInteractions"]["input"];
}>;

export type SetInteractionsMutation = {
  readonly __typename: "Mutation";
  readonly setInteractions: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly interactions: c.PartialUserInteractions;
  };
};

export const SetInteractionsDocument = /*#__PURE__*/ gql`
  mutation SetInteractions($interactions: PartialUserInteractions!) {
    setInteractions(interactions: $interactions) {
      id
      interactions
    }
  }
`;
export type SetInteractionsMutationFn = Apollo.MutationFunction<
  SetInteractionsMutation,
  SetInteractionsMutationVariables
>;

/**
 * __useSetInteractionsMutation__
 *
 * To run a mutation, you first call `useSetInteractionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInteractionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInteractionsMutation, { data, loading, error }] = useSetInteractionsMutation({
 *   variables: {
 *      interactions: // value for 'interactions'
 *   },
 * });
 */
export function useSetInteractionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetInteractionsMutation,
    SetInteractionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetInteractionsMutation,
    SetInteractionsMutationVariables
  >(SetInteractionsDocument, options);
}
export type SetInteractionsMutationHookResult = ReturnType<
  typeof useSetInteractionsMutation
>;
export type SetInteractionsMutationResult =
  Apollo.MutationResult<SetInteractionsMutation>;
export type SetInteractionsMutationOptions = Apollo.BaseMutationOptions<
  SetInteractionsMutation,
  SetInteractionsMutationVariables
>;
